import React, { useEffect, useRef, useCallback } from 'react';
import { Alert, Button, Checkbox, CircularProgress, FormControlLabel, FormGroup, Grid, IconButton, ListItem, ListItemButton, ListItemIcon, ListItemText, TextField, Tooltip, Typography, } from '@mui/material';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import CloseIcon from '@mui/icons-material/Close';
import { Box } from '@mui/system';
import { useTheme } from '@emotion/react';
import { useDispatch, useSelector } from 'react-redux';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import { styled } from '@mui/material/styles';
import { useState } from 'react';
import { jobActions } from '../../../redux/reducers/job-slice';
import useAxiosPrivate from '../../../hooks/use-axios-private';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { alertMsg, humanFileSize } from '../../../utils/basicUtils';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import moment from 'moment/moment';
import HelpIcon from '@mui/icons-material/Help';
const { breakTransfers } = window.electron;

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
	height: 4,
	borderRadius: 5,
	[`&.${linearProgressClasses.colorPrimary}`]: {
		backgroundColor: "#0b13451a",
	},
	[`& .${linearProgressClasses.bar}`]: {
		borderRadius: 5,
		backgroundColor: "#0B1345",

	},
}));

const { uploadImage, onUpdateTransfers, onUpdatePendingTransfers, sendTransferUpdates } = window.electron

const InprogressItem = ({ type, bytes, name, progress, speed, size, status }) => {
	return (
		<Box sx={{ px: 2, py: 0.5 }}>
			<ListItem disablePadding >
				<ListItemButton sx={{ py: 0, pl: 1, pr: 1.5, background: "#0b13450d", borderRadius: "6px", '&:hover': { background: "#0b13450d" } }}>
					<ListItemIcon sx={{ minWidth: "35px" }}>
						<UploadFileIcon sx={{ fontSize: "30px", }} />
					</ListItemIcon>
					<ListItemText
						primary={
							<>
								<Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
									<Box>
										<Typography sx={{ fontSize: "13px", fontWeight: 600 }} variant='span'>{`${status === 'pending' ? name.name : name}`}</Typography>
									</Box>

									<Box>
										{/* <Typography sx={{ fontSize: "13px" }} variant='span'>{status === 'pending' ? 'In queue' : `${progress}%`}</Typography> */}
										{status === 'inprogress' &&
											<Box sx={{ display: "flex", }}>
												<Box sx={{ minWidth: "70px", maxWidth: "100px" }}>
													<Typography sx={{ fontSize: "13px", textAlign: "right" }}>{`${humanFileSize(bytes)}`}</Typography>
												</Box>
												<Box sx={{ px: 0.3 }}>
													<Typography sx={{ fontSize: "13px" }}>/</Typography>
												</Box>
												<Box>
													<Typography sx={{ fontSize: "13px", }}>{` ${humanFileSize(size)}`}</Typography>
												</Box>
											</Box>
										}
									</Box>
								</Box>
							</>
						}
						secondary={
							<>
								<BorderLinearProgress variant={status === 'pending' ? 'indeterminate' : "determinate"} value={Number(progress)} />
								<Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
									{/* <Box>
									<Typography variant='span'>{status === 'pending' ? 'In queue' : `${progress}% - ${speed}`}</Typography>									
								</Box> */}
									<Box>
										<Typography color="primary" sx={{ fontSize: "13px" }}>{status === 'pending' ? 'In queue' : `${progress}%`}</Typography>
									</Box>
									<Box>
										<Typography color="primary" sx={{ fontSize: "13px" }}>{status === 'pending' ? 'In queue' : `${speed}`}</Typography>
									</Box>
								</Box>
							</>
						}
					/>
				</ListItemButton>
			</ListItem>
		</Box>
	)

}

const UploadImage = ({ itemData, index, onDelete, checkBoxChange, isChecked, onCancelledDelete, isTransferring }) => {
	const theme = useTheme();

	return (
		<Grid item key={itemData[index].name} sx={{ padding: "10px" }} >
			{!itemData[index].status
				&&
				<Box sx={{ borderRadius: '6px 6px 0px 0px', width: { xs: "180px", sm: "156px" }, height: "150px", background: "#ebecf0", display: "flex", alignItems: "center", justifyContent: "center" }}>
					<CircularProgress />
				</Box>
			}

			{itemData[index].status === 1 &&
				<Box sx={{ width: { xs: "180px", sm: "156px" }, height: "150px", position: "relative", borderRadius: '6px 6px 0px 0px', overflow: "hidden" }}>
					<img style={{ width: "100%", height: "100%", objectFit: "cover" }}
						src={`${itemData[index].preview_url}`}
						alt={itemData[index].name}
						loading="lazy" />
					{!isTransferring
						&&
						<>
							<IconButton sx={{ position: 'absolute', top: "0px", right: "0px", background: theme.palette.mode === "dark" ? "#5a5a5ac7" : "#ebecf0", borderRadius: "0 0 0 15px" }}
								className="image-del-icon"
								onClick={
									(e) => {
										if (e.detail === 1) {
											const img = {
												name: itemData[index].name,
												preview_url: itemData[index].preview_url,
												url: itemData[index].url,
												path: itemData[index].path,
												marked_image: itemData[index].marked_image,
												has_thumb: false
											}
											onDelete([img], [index]);
										}
									}
								}
								aria-label="delete" size="small"
								color='primary'
							>
								<DeleteOutlineOutlinedIcon fontSize="small" />
							</IconButton>
							<FormGroup className='checkbox-pad' sx={{ position: 'absolute', top: "0px", left: "0px", background: theme.palette.mode === "dark" ? "#5a5a5ac7" : "#ebecf0", borderRadius: "0 0 15px 0" }}>
								<FormControlLabel
									sx={{ m: 0, padding: "0px" }}
									control={<Checkbox
										checked={isChecked}
										onChange={(e) => { checkBoxChange(e) }}
									/>}
								/>
							</FormGroup>
						</>
					}
					<Box sx={{ position: 'absolute', width: "100%", bottom: "0px", left: "0px", background: "#00000061", borderRadius: "0 0 15px 0", boxShadow: "1px 1px 2px 0px #0b134554" }}>
						<Typography variant="body2" color="initial" sx={{
							textTransform: "uppercase", padding: "2px 2px 2px 4px", fontSize: 12, color: "#fff",
							overflow: "hidden",
							textOverflow: "ellipsis",
							display: "-webkit-box",
							WebkitLineClamp: "1",
							WebkitBoxOrient: "vertical",
						}}>
							{humanFileSize(itemData[index].file_size)}
						</Typography>
					</Box>
				</Box>
			}

			{itemData[index].status === 2
				&&
				<Box sx={{ width: { xs: "100%", sm: "156px" }, height: "150px", background: "#ebecf0", display: "flex", alignItems: "center", justifyContent: "center" }}>
					<IconButton
						onClick={() => {
							if (isTransferring) {
								return false
							}
							onCancelledDelete();
						}}
					>
						<CloseIcon />
					</IconButton>
				</Box>
			}
			<Box sx={{ width: { xs: "180px", sm: "156px" }, backgroundColor: theme.palette.mode === "dark" ? '#5a5a5a' : '#ebecf0', borderRadius: "0px 0px 6px 6px", overflow: "hidden" }}>
				<Typography sx={{
					overflow: "hidden",
					textOverflow: "ellipsis",
					display: "-webkit-box",
					WebkitLineClamp: "1",
					WebkitBoxOrient: "vertical",
					margin: '8px',
				}} component="p" fontSize={13} >{itemData[index].name}</Typography>
			</Box>
		</Grid>
	)
}

const InProgress = () => {
	const [transfers, setTransfers] = useState({})
	useEffect(() => {
		sendTransferUpdates(false)
		onUpdateTransfers((e, t) => {
			setTransfers(t)
		})

		return () => {
			sendTransferUpdates(false)
		}
	}, [])

	return (
		<>
			{
				Object.keys(transfers).map((key, index) => {
					return (
						<InprogressItem status="inprogress" key={key} {...transfers[key]} />
					)
				})
			}
		</>
	)
}

const Pending = () => {
	const [pendingTransfers, setPendingTransfers] = useState([])
	useEffect(() => {
		onUpdatePendingTransfers((e, t) => {
			setPendingTransfers(t)
		})

		return () => {
			sendTransferUpdates(false)
		}
	}, [])

	return (
		pendingTransfers.map((item, index) => {
			return (
				<InprogressItem status="pending" key={item} name={item} />
			)
		})
	)
}

const UploadImageStep = ({ enableNext, enableBack }) => {
	const controllerRef = useRef(new AbortController())
	const isUnmounted = useRef(false);
	const canceltransferRef = useRef(false)
	const [isTransferring, setIsTransferring] = useState(false)
	const theme = useTheme();
	const dispatch = useDispatch()
	const job = useSelector(state => state.job)
	const axios = useAxiosPrivate()
	const [deleteSelected, setDeleteSelected] = useState([])
	const timestamp = useRef(moment.utc())

	useEffect(() => {
		isUnmounted.current = false
		return () => {
			isUnmounted.current = true
			breakTransfers()
		}
	}, [])

	useEffect(() => {
		!isTransferring ? enableBack(true) : enableBack(false)
	}, [isTransferring, enableBack])

	const handleChange = (event, index, item) => {
		setDeleteSelected(
			prev => {
				if (!prev.includes(index)) {
					prev.push(index)
				}
				else {
					const position = deleteSelected.indexOf(index)
					if (position >= 0) {
						prev.splice(position, 1)
					}
				}
				return [...prev]
			}
		)
	}

	const deleteUploadImage = async (img, index) => {
		try {
			const resp = await axios.post("jobs/delete_upload_image/", {
				"job_id": job.job_id,
				"path": img
			})
			// dispatch(jobActions.removeMedia([...img]))
			dispatch(jobActions.updateJob(resp.data.data))
			setDeleteSelected([])
		}

		catch (error) {
			console.log(error)
		}
	}

	const checkFiles = useCallback(
		async (uploadedList = []) => {
			try {
				const resp = await axios.post('jobs/confirm_media/', { job_id: job.job_id, media_created_on: moment(timestamp).format('Y-MM-DD'), uploaded_list: uploadedList })
				if (isUnmounted.current) {
					return false
				}
				dispatch(jobActions.updateJob(resp.data.data))
				console.log("🚀 ~ file: UploadImageStep.jsx:147 ~ resp.data:", resp.data)
			}
			catch (err) {
				console.log("🚀 ~ file: UploadImageStep.jsx:150 ~ err:", err)
			}
		},
		[],
	)

	const uploadImagesOverFTP = async (e) => {
		if (e.detail !== 1) {
			return
		}
		setIsTransferring(true)
		try {
			sendTransferUpdates(true);
			const resp = await uploadImage(job.media_path.raw_path, job.job_id)
			console.log("🚀 ~ file: UploadImageStep.jsx:268 ~ uploadImagesOverFTP ~ resp:", resp)
			sendTransferUpdates(false);
			if (!resp) {
				console.log("🚀 ~ file: UploadImageStep.jsx:279 ~ uploadImagesOverFTP ~ uploadedList:", uploadedList)
				checkFiles([])
				alertMsg('Some transfers have failed, check log for details', 'error')
				return false
			}
			const uploadedList = resp.files.map(file => {
				file.file_size = file['size']
				file.name = file['filename']
				delete file['size']
				delete file['filename']
				delete file['path']
				delete file['status']
				return {
					...file
				}
			})
			if (resp.length > 0) {
				alertMsg('Transfer successful', 'success')
			}
			checkFiles(uploadedList)
		}
		catch (err) {
			console.log("🚀 ~ file: UploadImageStep.jsx:254 ~ err:", err)
		}
		finally {
			setIsTransferring(false)
		}
	}
	useEffect(() => {
		enableNext(job.media.length > 0 && !isTransferring)
		return () => {
			enableNext(false)
		}
	}, [enableNext, job.media, isTransferring])

	const validateOutputFilecount = () => {
		let result = {
			message: '',
			isValid: false
		}

		if (job.media.length === 0 && job.output_file_count != 0) {
			result.message = "Please upload some images"
			return result
		}
		if (job.output_file_count < 0) {
			result.message = "Output file count should be greater than zero"
			return result
		}
		if (job.output_file_count > 0 && (job.media.length < job.output_file_count)) {
			result.message = `Output file count should not exceed ${job.media.length}`
			return result
		}
		if (job.media.length > 0 && job.output_file_count == 0) {
			result.message = `Output file count cannot be zero`
			return result
		}
		result.isValid = true
		return result
	}

	return (
		<Box
			onDragOver={(e) => {
				e.stopPropagation();
				e.preventDefault();
			}}
			onDrop={e => {
				e.stopPropagation();
				e.preventDefault();
			}}
			component="div"
			sx={{ position: 'relative', mt: deleteSelected.length > 0 && { xs: 7, sm: 0 } }}
		>

			<Box className="overflow-scroll" sx={{ maxHeight: { xs: "70vh", sm: "45vh", xl: "50vh" }, overflowY: 'auto', border: "2px dashed grey", mt: 4, pb: 2, borderRadius: "4px" }}>
				{job.media.length > 0 &&
					<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 3, mb: 2, backgroundColor: theme.palette.mode === "dark" ? '#5a5a5a87' : '#ebecf0', position: "sticky", width: "100%", top: 0, zIndex: 1 }}>
						<Button
							variant="contained"
							color="primary"
							component="span"
							startIcon={<CloudUploadOutlinedIcon />}
							onClick={uploadImagesOverFTP}
							disabled={isTransferring}
						>
							Select File
							{isTransferring && <CircularProgress sx={{ width: "22px !important", height: "22px !important", verticalAlign: "middle", ml: 1, color: "#fff" }} />}
						</Button>
					</Box>
				}
				{!job.media.length > 0 &&
					<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 5, px: 3, height: "100%", }}>
						<Box >
							<Button
								onClick={uploadImagesOverFTP}
								variant="contained"
								color="primary"
								component="span"
								startIcon={<CloudUploadOutlinedIcon />}
								disabled={isTransferring}
							>
								Select File
								{isTransferring && <CircularProgress sx={{ width: "22px !important", height: "22px !important", verticalAlign: "middle", ml: 1, color: "#fff" }} />}
							</Button>
						</Box>
					</Box>
				}
				{isTransferring &&
					<Alert severity="info" sx={{ maxWidth: '50%', mx: "auto", display: "flex", justifyContent: "center", mb: 3 }}>Please wait while images are being uploaded..</Alert>
				}
				<InProgress />
				<Pending />

				{
					job.media.length > 0 && <Grid container sx={{ padding: "10px", justifyContent: 'center' }}>
						{job.media.map((item, index) => (

							<UploadImage
								onCancelledDelete={() => { }}
								key={item.name}
								itemData={job.media}
								index={index}
								onDelete={deleteUploadImage}
								isChecked={deleteSelected.includes(index)}
								checkBoxChange={
									(e) => {
										handleChange(e, index, item)
									}
								}
								isTransferring={isTransferring}
							/>

						))}
					</Grid>
				}

			</Box>

			<Box sx={{ mt: 2 }}>
				<Grid container spacing={2} flexDirection={{ xs: "column-reverse", sm: "row" }}>
					<Grid item xs={12} sm={4}>
						{
							job.media.length > 0 && !isTransferring &&
							<Button sx={{ mr: 1, mb: { xs: 2, md: 0 } }} color='primary' variant="outlined"
								// sx={{ position: 'absolute', bottom: { xs: -50, sm: -70 } }}
								className='delete-selected-btn'
								onClick={() => {
									if (job.media.length === deleteSelected.length) {
										setDeleteSelected([])
										return
									}
									let ids = []
									for (let i = 0; i < job.media.length; i++) {
										ids.push(i)
									}
									setDeleteSelected(ids)
								}}
							>{job.media.length === deleteSelected.length ? "Unselect all" : "Select All"}</Button>
						}

						{
							deleteSelected.length > 0
							&& !isTransferring &&
							<Button color='error' variant="outlined"
								sx={{ mb: { xs: 2, md: 0 } }}
								className='delete-selected-btn'
								onClick={() => {
									let imgList = []
									deleteSelected.forEach((imgIndex) => {
										imgList.push(job.media[imgIndex])
									})
									deleteUploadImage(imgList)
								}}
							>Delete Selected ({deleteSelected.length})</Button>
						}
						{false && isTransferring &&
							<Button
								variant="outlined"
								className='delete-selected-btn'
								onClick={() => breakTransfers()}
							// sx={{ position: 'absolute', bottom: { xs: -50, sm: -70 } }}
							>
								Cancel pending Transfer
							</Button>
						}
					</Grid>
					<Grid item xs={12} sm={4}>
						<Box sx={{ textAlign: "center" }}>
							{false && <Button variant='outlined' disabled={isTransferring} onClick={() => checkFiles()}>Check files</Button>}
						</Box>
					</Grid>
					<Grid item xs={12} sm={4}>
						<Box sx={{ textAlign: "right" }}>
							{
								<Box>
									<CheckCircleIcon sx={{ fontSize: { xs: "20px", xl: "22px" }, verticalAlign: "middle", mr: 1 }} color='success' />
									<Typography variant='span' sx={{ fontSize: { xs: "14px", xl: "16px" } }}>{job.media.length} images uploaded</Typography>
								</Box>
							}
						</Box>
						<Box sx={{ textAlign: "right", mt: 2, width: { xs: "70%", sm: "70%", md: "55%", lg: "50%", xl: "40%" }, marginLeft: "auto" }}>
							<TextField
								type='number'
								onFocus={(e) => { e.target.select() }}
								error={!validateOutputFilecount().isValid}
								onKeyDown={(e) => {
									(["e", "E", "+", "-"].includes(e.key) || (e.target.value === '' && e.key === '.')) && e.preventDefault()
								}}
								helperText={validateOutputFilecount().message}
								size='small'
								label={<><>Output file count</> <Tooltip title="Output file count will helps us in accurate and effective calculation of pricing with respective to input file count">
									<HelpIcon sx={{ position: "relative", top: "4px" }} fontSize="small" /></Tooltip></>}
								value={job.output_file_count} name="output_file_count" onChange={(e) => dispatch(jobActions.updateOutputFileCount(e.target.value.replaceAll(".", "") || 0))} autoComplete='off' />
						</Box>
					</Grid>
				</Grid>
			</Box>
		</Box >
	);
}


export default UploadImageStep;